import React, { useEffect, useState } from 'react'
import Layout from '../layout/Layout'
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import Table from "react-bootstrap/Table";
import Form from "react-bootstrap/Form";
import ScrollingTab from '../components/ScrollingTab';
import ReportedStories from './ReportedStories';
import ReportedBoard from './ReportedBoard';
import CustomFormInput from '../components/CustomFormInput';
import CustomPagination from '../components/CustomPagination';
import { editActivity, editComment, getAllActivity, getAlLComment, getAlLReplyComment, deleteFlaggedActivity, refreshReportedCount, getReportedPendingCount } from '../controller';
import { requestHandler } from '../helper';
import { formatDateAsItIs } from '../helper/common';
import Loader from '../components/Loader';
import { toast } from 'react-toastify';
import { Modal, Carousel } from 'react-bootstrap';
import { imagePath } from '../helper/image';

function ActivityManagement() {

    const [selectedActions, setSelectedActions] = useState({});
    const [activeTab, setActiveTab] = useState("flaggedActivity");
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [pendingAction, setPendingAction] = useState({ id: null, action: null });
    const [showImageModal, setShowImageModal] = useState(false);
    const [selectedImages, setSelectedImages] = useState([]);

    // pending reports per tab (shown as a badge on each tab); recounted after every admin action
    const [pendingCounts, setPendingCounts] = useState({});
    useEffect(() => {
        const load = () => requestHandler(
            async () => await getReportedPendingCount(),
            null,
            (res) => setPendingCounts(res.data || {}),
            () => { }
        );
        load();
        window.addEventListener('reported-count-refresh', load);
        return () => window.removeEventListener('reported-count-refresh', load);
    }, []);
    const tabBadge = (key) => pendingCounts[key] > 0 ? <span className="tab-badge">{pendingCounts[key] > 99 ? '99+' : pendingCounts[key]}</span> : null;

    const handleButtonClickComment = (id, action) => {
        setPendingAction({ id, action });
        setShowConfirmModal(true);
    };

    const handleButtonClickActivity = (id, action) => {
        setPendingAction({ id, action });
        setShowConfirmModal(true);
    };

    const confirmActivityAction = () => {
        const { id, action } = pendingAction;
        const status = action === 'approve' ? 1 : 2;

        setSelectedActions((prevState) => ({
            ...prevState,
            [id]: action,
        }));

        requestHandler(
            async () => await editActivity({ status: status }, id),
            setLoading,
            (res) => {
                toast.success(res.message);
                refreshReportedCount();
                getActivityData(1);
            },
            () => { }
        );

        setShowConfirmModal(false);
        setPendingAction({ id: null, action: null });
    };

    const confirmDeleteActivity = () => {
        const { id } = pendingAction;
        requestHandler(
            async () => await deleteFlaggedActivity(id),
            setLoading,
            (res) => {
                toast.success(res.message);
                refreshReportedCount();
                if (activeTab === "flaggedActivity") {
                    getActivityData(1);
                } else if (activeTab === "flaggedComments") {
                    getCommentData(1);
                } else if (activeTab === "flaggedReplyComments") {
                    getReplyCommentData(1);
                }
            },
            () => { }
        );
        setShowConfirmModal(false);
        setPendingAction({ id: null, action: null });
    };


    const confirmAction = () => {
        const { id, action } = pendingAction;
        const status = action === 'approve' ? 1 : 2;

        setSelectedActions((prevState) => ({
            ...prevState,
            [id]: action,
        }));

        requestHandler(
            async () => await editComment({ status: status }, id),
            setLoading,
            (res) => {
                toast.success(res.message);
                refreshReportedCount();
                getCommentData(1);
            },
            () => { }
        );

        // Reset modal
        setShowConfirmModal(false);
        setPendingAction({ id: null, action: null });
    };

    const confirmActionReply = () => {
        const { id, action } = pendingAction;
        const status = action === 'approve' ? 1 : 2;

        setSelectedActions((prevState) => ({
            ...prevState,
            [id]: action,
        }));

        requestHandler(
            async () => await editComment({ status: status }, id),
            setLoading,
            (res) => {
                toast.success(res.message);
                refreshReportedCount();
                getReplyCommentData(1);
            },
            () => { }
        );

        // Reset modal
        setShowConfirmModal(false);
        setPendingAction({ id: null, action: null });
    };
    const [activityData, setActivityData] = useState([]);
    const [commentData, setCommentData] = useState([]);
    const [replyCommentData, setReplyCommentData] = useState([]);

    //activity
    const [paginationValue, setPaginationValue] = useState({
        page: 1,
        limit: 10,
        totalData: 0,
        totalPages: 0
    })

    const { page, limit, totalData, totalPages } = paginationValue
    const start = (page - 1) * limit + 1;
    const end = Math.min(page * limit, totalData);

    //comment
    const [paginationCommentValue, setPaginationCommentValue] = useState({
        page: 1,
        limit: 10,
        totalData: 0,
        totalPages: 0
    })

    const commentStart = (paginationCommentValue.page - 1) * paginationCommentValue.limit + 1;
    const commentEnd = Math.min(paginationCommentValue.page * paginationCommentValue.limit, paginationCommentValue.totalData);
    const commentTotalData = paginationCommentValue.totalData;

    //replycomment
    const [paginationReplyCommentValue, setPaginationReplyCommentValue] = useState({
        page: 1,
        limit: 10,
        totalData: 0,
        totalPages: 0
    })

    const replyCommentStart = (paginationReplyCommentValue.page - 1) * paginationReplyCommentValue.limit + 1;
    const replyCommentEnd = Math.min(paginationReplyCommentValue.page * paginationReplyCommentValue.limit, paginationReplyCommentValue.totalData);
    const replyCommentTotalData = paginationReplyCommentValue.totalData;

    const getActivityData = async (page = 1) => {
        await requestHandler(
            async () => await getAllActivity(limit, page, search),
            setLoading,
            (res) => {
                const { data, limit, page, totalData, totalPages } = res.data;
                setActivityData(data);
                setPaginationValue({
                    page,
                    limit,
                    totalData,
                    totalPages
                })
            },
            () => { }
        );
    };

    const getCommentData = async (page = 1) => {
        await requestHandler(
            async () => await getAlLComment(paginationCommentValue.limit, page, search),
            setLoading,
            (res) => {
                const { data, limit, page, totalData, totalPages } = res.data;
                setCommentData(data);
                setPaginationCommentValue({
                    page,
                    limit,
                    totalData,
                    totalPages
                })
            },
            () => { }
        );
    };


    const getReplyCommentData = async (page = 1) => {
        await requestHandler(
            async () => await getAlLReplyComment(paginationReplyCommentValue.limit, page, search),
            setLoading,
            (res) => {
                const { data, limit, page, totalData, totalPages } = res.data;
                setReplyCommentData(data);
                setPaginationReplyCommentValue({
                    page,
                    limit,
                    totalData,
                    totalPages
                })
            },
            () => { }
        );
    };

    useEffect(() => {
        if (activeTab === "flaggedActivity") {
            if (search) {
                const delayDebounce = setTimeout(() => {
                    getActivityData(1);
                }, 500);
                return () => clearTimeout(delayDebounce);
            } else {
                getActivityData(1);
            }
        }
        if (activeTab === "flaggedComments") {
            if (search) {
                const delayDebounce = setTimeout(() => {
                    getCommentData(1);
                }, 500);
                return () => clearTimeout(delayDebounce);
            } else {
                getCommentData(1);
            }
        }
        if (activeTab === "flaggedReplyComments") {
            if (search) {
                const delayDebounce = setTimeout(() => {
                    getReplyCommentData(1);
                }, 500);
                return () => clearTimeout(delayDebounce);
            } else {
                getReplyCommentData(1);
            }
        }

        // eslint-disable-next-line
    }, [paginationValue.limit, search, activeTab, paginationCommentValue.limit, paginationReplyCommentValue.limit]);

    const handlePageChange = (page, type) => {
        if (type === 'activity') {
            setPaginationValue((prev) => ({
                ...prev,
                page,
            }));
            getActivityData(page); // Update the page when changing page for activity tab
        } else if (type === 'comment') {
            setPaginationCommentValue((prev) => ({
                ...prev,
                page,
            }))
            getCommentData(page); // Update the page when changing page for comment tab

        }
        else if (type === 'replycomment') {
            setPaginationReplyCommentValue((prev) => ({
                ...prev,
                page,
            }))
            getReplyCommentData(page); // Update the page when changing page for replycomment tab
        }

    };

    // Function to handle image click
    const handleImageClick = (activityImage) => {
        if (activityImage.length > 0) {
            setSelectedImages(activityImage.map(img => ({ url: img.url, type: img.type })));
            setShowImageModal(true);
        }
    };

    // Function to get image URL
    const getImageUrl = (imgPath) => {
        if (!imgPath) return '';

        if (imgPath.startsWith('http://') || imgPath.startsWith('https://')) {
            return imgPath;
        }
        return `${imagePath()}${imgPath}`;
    };

    return (
        <>
            {loading && <Loader />}
            <Layout>
                <div className="card-wrapper">
                    <div className="card-header border-bottom-0 pb-0">
                        <div className='theme-select'>
                            <Form.Select required name="limit" onChange={e => setPaginationValue({ ...paginationValue, [e.target.name]: e.target.value })}>
                                <option >10</option>
                                <option >15</option>
                                <option >20</option>
                            </Form.Select>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                            <div className="search-input">
                                <img src="/images/svg/search.svg" className="search-icon" alt="icon" />
                                <CustomFormInput
                                    type="search"
                                    placeholder="Search by user & title..."
                                    id="search"
                                    className="mb-0"
                                    value={search}
                                    name='search'
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <Tab.Container id="activityTab" activeKey={activeTab} onSelect={(key) => setActiveTab(key)}>
                            <ScrollingTab>
                                <Nav className='theme-tab'>
                                    <Nav.Item>
                                        <Nav.Link eventKey="flaggedActivity">Flagged Activity{tabBadge('activity')}</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="flaggedComments">Flagged Comments{tabBadge('comment')}</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="flaggedReplyComments">Flagged Reply Comments{tabBadge('replyComment')}</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="flaggedStories">Flagged Stories{tabBadge('story')}</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="flaggedBoard">Flagged Board Posts{tabBadge('board')}</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </ScrollingTab>
                            <Tab.Content className='mt-3'>
                                <Tab.Pane eventKey="flaggedActivity">
                                    <div className="overflow-x-auto theme-scrollbar">
                                        <Table className="theme-table">
                                            <thead>
                                                <tr>
                                                    {/* <th>ID</th> */}
                                                    <th>Post By</th>
                                                    <th>Post Title</th>
                                                    <th>Post Date</th>
                                                    <th>Reported By</th>
                                                    <th>Flagged Reason</th>
                                                    <th>Reported Date</th>
                                                    <th>Images</th>
                                                    <th>Status</th>
                                                    <th width="200" className='text-center'>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {activityData?.length > 0 ? (
                                                    activityData.map((row) => {
                                                        if (row.reportId.length === 0) {
                                                            return (
                                                                <tr key={row.id}>
                                                                    <td colSpan={10} className="text-center p-5 fs-5">
                                                                        No Records Found
                                                                    </td>
                                                                </tr>
                                                            );
                                                        }

                                                        // If there are multiple reports, render one <tr> per report
                                                        return row.reportId.map((report, index) => (
                                                            <tr key={`${row.id}-${index}`}>
                                                                <td>{row?.userId?.firstName + " " + row?.userId?.lastName}</td>
                                                                <td style={{ minWidth: "200px" }}>{row?.des || "-"}</td>
                                                                <td>{formatDateAsItIs(row?.createdAt)}</td>
                                                                <td>{report?.senderId?.firstName + " " + report?.senderId?.lastName || "-"}</td>
                                                                <td>{report?.reason || "-"}</td>
                                                                <td>{formatDateAsItIs(report?.createdAt)}</td>
                                                                <td>
                                                                    {(() => {
                                                                        if (row?.activity_image.length === 0) {
                                                                            return <span>-</span>;
                                                                        }
                                                                        const firstImage = row?.activity_image[0].thumbnail ? row?.activity_image[0].thumbnail : row?.activity_image[0].url || "-";
                                                                        const remainingCount = row?.activity_image.length - 1;

                                                                        return (
                                                                            <div
                                                                                style={{
                                                                                    position: 'relative',
                                                                                    display: 'inline-block',
                                                                                    cursor: 'pointer'
                                                                                }}
                                                                                onClick={() => handleImageClick(row?.activity_image)}
                                                                            >
                                                                                <img
                                                                                    src={getImageUrl(firstImage)}
                                                                                    alt="Activity"
                                                                                    style={{
                                                                                        width: '80px',
                                                                                        height: '80px',
                                                                                        objectFit: 'cover',
                                                                                        borderRadius: '8px',
                                                                                        border: '1px solid #ddd'
                                                                                    }}
                                                                                    // onError={(e) => {
                                                                                    //     e.target.src = '/images/placeholder.png';
                                                                                    //     e.target.onerror = null;
                                                                                    // }}
                                                                                />
                                                                                {remainingCount > 0 && (
                                                                                    <span
                                                                                        style={{
                                                                                            position: 'absolute',
                                                                                            top: '-8px',
                                                                                            right: '-8px',
                                                                                            backgroundColor: '#dc3545',
                                                                                            color: '#fff',
                                                                                            borderRadius: '50%',
                                                                                            width: '24px',
                                                                                            height: '24px',
                                                                                            display: 'flex',
                                                                                            alignItems: 'center',
                                                                                            justifyContent: 'center',
                                                                                            fontSize: '12px',
                                                                                            fontWeight: 'bold',
                                                                                            border: '2px solid #fff',
                                                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                                                                        }}
                                                                                    >
                                                                                        +{remainingCount}
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                        );
                                                                    })()}
                                                                </td>
                                                                <td>
                                                                    <ul className="table-status">
                                                                        <li
                                                                            className={
                                                                                row.status === 0
                                                                                    ? 'status-danger'
                                                                                    : row.status === 2
                                                                                        ? 'status-danger'
                                                                                        : 'status-success'
                                                                            }
                                                                        >
                                                                            {row.status === 0
                                                                                ? 'Pending'
                                                                                : row.status === 2
                                                                                    ? 'Rejected'
                                                                                    : 'Approved'}
                                                                        </li>
                                                                    </ul>
                                                                </td>
                                                                <td width={220}>
                                                                    <div className='d-flex gap-3 justify-content-center align-items-center'>
                                                                        {row.status === 0 && (
                                                                            <>
                                                                                <button
                                                                                    className={`btn btn-light-danger ${selectedActions[row._id] === 'reject' ? 'active' : ''}`}
                                                                                    onClick={() => handleButtonClickActivity(row._id, 'reject')}
                                                                                >
                                                                                    <img src="/images/svg/table-false.svg" alt="icon" />
                                                                                </button>
                                                                                <button
                                                                                    className={`btn btn-light-success ${selectedActions[row._id] === 'approve' ? 'active' : ''}`}
                                                                                    onClick={() => handleButtonClickActivity(row._id, 'approve')}
                                                                                >
                                                                                    <img src="/images/svg/table-true.svg" alt="icon" />
                                                                                </button>
                                                                            </>
                                                                        )}
                                                                        {/* Show Delete button if status is 0, 1, or 2 */}
                                                                        {(row.status === 1 || row.status === 2) && (
                                                                            <button
                                                                                className={`btn btn-light-danger ${selectedActions[row._id] === 'delete' ? 'active' : ''}`}
                                                                                onClick={() => handleButtonClickActivity(row._id, 'delete')}
                                                                            >
                                                                                <img src="/images/svg/table-delete.svg" alt="icon" />
                                                                            </button>
                                                                        )}
                                                                    </div>

                                                                </td>
                                                            </tr>
                                                        ));
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={10} className="text-center p-5 fs-5">
                                                            No Records Found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap mt-1">
                                        <p className="mb-0 fs-16 fw-500 text-light">
                                            Showing {start} to {end} of {totalData} entries
                                        </p>
                                        {totalPages > 1 && (
                                            <CustomPagination
                                                currentPage={page}
                                                totalPages={totalPages}
                                                onPageChange={(page) => handlePageChange(page, 'activity')}
                                            />
                                        )}
                                    </div>
                                </Tab.Pane>

                                <Tab.Pane eventKey="flaggedComments">
                                    <div className="overflow-x-auto theme-scrollbar">
                                        <Table className="theme-table">
                                            <thead>
                                                <tr>
                                                    {/* <th>ID</th> */}
                                                    <th>Username</th>
                                                    <th>Comment</th>
                                                    <th>Post Date</th>
                                                    <th>Flagged Reason</th>
                                                    <th>Images</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Boolean(commentData?.length) ? commentData.map((row) => (
                                                    <tr key={row.id}>
                                                        {/* <td>{row.id}</td> */}
                                                        <td>{row?.userId?.firstName + " " + row?.userId?.lastName}</td>
                                                        <td style={{ minWidth: "200px" }}>{row?.comment}</td>
                                                        <td>{formatDateAsItIs(row?.createdAt)}</td>
                                                        <td>{row?.reportId[0]?.reason || "-"}</td>
                                                        <td>
                                                            {(() => {
                                                                if (!row?.activityId?.activity_image?.length) {
                                                                    return <span>-</span>;
                                                                }
                                                                const firstImage = row?.activityId?.activity_image[0].thumbnail ? row?.activityId?.activity_image[0].thumbnail : row?.activityId?.activity_image[0].url || "-";
                                                                const remainingCount = row?.activityId?.activity_image?.length - 1;

                                                                return (
                                                                    <div
                                                                        style={{
                                                                            position: 'relative',
                                                                            display: 'inline-block',
                                                                            cursor: 'pointer'
                                                                        }}
                                                                        onClick={() => handleImageClick(row?.activityId?.activity_image)}
                                                                    >
                                                                        <img
                                                                            src={getImageUrl(firstImage)}
                                                                            alt="Activity"
                                                                            style={{
                                                                                width: '80px',
                                                                                height: '80px',
                                                                                objectFit: 'cover',
                                                                                borderRadius: '8px',
                                                                                border: '1px solid #ddd'
                                                                            }}
                                                                            // onError={(e) => {
                                                                            //     e.target.src = '/images/placeholder.png';
                                                                            //     e.target.onerror = null;
                                                                            // }}
                                                                        />
                                                                        {remainingCount > 0 && (
                                                                            <span
                                                                                style={{
                                                                                    position: 'absolute',
                                                                                    top: '-8px',
                                                                                    right: '-8px',
                                                                                    backgroundColor: '#dc3545',
                                                                                    color: '#fff',
                                                                                    borderRadius: '50%',
                                                                                    width: '24px',
                                                                                    height: '24px',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    fontSize: '12px',
                                                                                    fontWeight: 'bold',
                                                                                    border: '2px solid #fff',
                                                                                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                                                                }}
                                                                            >
                                                                                +{remainingCount}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </td>
                                                        <td>
                                                            <ul className="table-status">
                                                                <li className={row?.status === 0 ? 'status-danger' : row?.status === 2 ? 'status-danger' : 'status-success'}>
                                                                    {row.status === 0 ? 'Pending' : row.status === 2 ? 'Rejected' : 'Approved'}
                                                                </li>
                                                            </ul>
                                                        </td>
                                                        <td width={220}>
                                                            {row.status === 0 && (
                                                                <div className="d-flex align-items-center gap-2">
                                                                    <button
                                                                        className={`btn btn-light-danger ${selectedActions[row._id] === 'reject' ? 'active' : ''}`}
                                                                        onClick={() => handleButtonClickComment(row._id, 'reject')}
                                                                    >
                                                                        <img src="/images/svg/table-false.svg" alt="icon" />
                                                                    </button>
                                                                    <button
                                                                        className={`btn btn-light-success ${selectedActions[row._id] === 'approve' ? 'active' : ''}`}
                                                                        onClick={() => handleButtonClickComment(row._id, 'approve')}
                                                                    >
                                                                        <img src="/images/svg/table-true.svg" alt="icon" />
                                                                    </button>
                                                                </div>
                                                            )}

                                                            {(row.status === 1 || row.status === 2) && (
                                                                <button
                                                                    className={`btn btn-light-danger ${selectedActions[row._id] === 'delete' ? 'active' : ''}`}
                                                                    onClick={() => handleButtonClickComment(row._id, 'delete')}
                                                                >
                                                                    <img src="/images/svg/table-delete.svg" alt="icon" />
                                                                </button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                )) : (
                                                    <tr>
                                                        <td colSpan={10} className='text-center p-5 fs-5'>
                                                            No Records Found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap mt-1">
                                        <p className="mb-0 fs-16 fw-500 text-light">
                                            Showing {commentStart} to {commentEnd} of {commentTotalData} entries
                                        </p>

                                        {paginationCommentValue.totalPages > 1 && (
                                            <CustomPagination
                                                currentPage={paginationCommentValue.page}
                                                totalPages={paginationCommentValue.totalPages}
                                                onPageChange={(page) => handlePageChange(page, 'comment')}
                                            />
                                        )}
                                    </div>
                                </Tab.Pane>

                                <Tab.Pane eventKey="flaggedReplyComments">
                                    <div className="overflow-x-auto theme-scrollbar">
                                        <Table className="theme-table">
                                            <thead>
                                                <tr>
                                                    {/* <th>ID</th> */}
                                                    <th>Username</th>
                                                    <th>Reply Comment</th>
                                                    <th>Post Date</th>
                                                    <th>Flagged Reason</th>
                                                    <th>Images</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Boolean(replyCommentData?.length) ? replyCommentData.map((row) => (
                                                    <tr key={row.id}>
                                                        {/* <td>{row.id}</td> */}
                                                        <td>{row?.userId?.firstName + " " + row?.userId?.lastName}</td>
                                                        <td style={{ minWidth: "200px" }}>{row?.comment}</td>
                                                        <td>{formatDateAsItIs(row?.createdAt)}</td>
                                                        <td>{row?.reportId[0]?.reason || "-"}</td>
                                                        <td>
                                                            {(() => {
                                                                if (!row?.activityId?.activity_image?.length) {
                                                                    return <span>-</span>;
                                                                }
                                                                const firstImage = row?.activityId?.activity_image[0].thumbnail ? row?.activityId?.activity_image[0].thumbnail : row?.activityId?.activity_image[0].url || "-";
                                                                const remainingCount = row?.activityId?.activity_image?.length - 1;

                                                                return (
                                                                    <div
                                                                        style={{
                                                                            position: 'relative',
                                                                            display: 'inline-block',
                                                                            cursor: 'pointer'
                                                                        }}
                                                                        onClick={() => handleImageClick(row?.activityId?.activity_image)}
                                                                    >
                                                                        <img
                                                                            src={getImageUrl(firstImage)}
                                                                            alt="Activity"
                                                                            style={{
                                                                                width: '80px',
                                                                                height: '80px',
                                                                                objectFit: 'cover',
                                                                                borderRadius: '8px',
                                                                                border: '1px solid #ddd'
                                                                            }}
                                                                            // onError={(e) => {
                                                                            //     e.target.src = '/images/placeholder.png';
                                                                            //     e.target.onerror = null;
                                                                            // }}
                                                                        />
                                                                        {remainingCount > 0 && (
                                                                            <span
                                                                                style={{
                                                                                    position: 'absolute',
                                                                                    top: '-8px',
                                                                                    right: '-8px',
                                                                                    backgroundColor: '#dc3545',
                                                                                    color: '#fff',
                                                                                    borderRadius: '50%',
                                                                                    width: '24px',
                                                                                    height: '24px',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    fontSize: '12px',
                                                                                    fontWeight: 'bold',
                                                                                    border: '2px solid #fff',
                                                                                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                                                                }}
                                                                            >
                                                                                +{remainingCount}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </td>
                                                        <td>
                                                            <ul className="table-status">
                                                                <li className={row.status === 0 ? 'status-danger' : row.status === 2 ? 'status-danger' : 'status-success'}>
                                                                    {row.status === 0 ? 'Pending' : row.status === 2 ? 'Rejected' : 'Approved'}
                                                                </li>
                                                            </ul>
                                                        </td>
                                                        <td width={220}>
                                                            {row.status === 0 && (
                                                                <div className="d-flex align-items-center gap-2">
                                                                    <button
                                                                        className={`btn btn-light-danger ${selectedActions[row._id] === 'reject' ? 'active' : ''}`}
                                                                        onClick={() => handleButtonClickComment(row._id, 'reject')}
                                                                    >
                                                                        <img src="/images/svg/table-false.svg" alt="icon" />
                                                                    </button>
                                                                    <button
                                                                        className={`btn btn-light-success ${selectedActions[row._id] === 'approve' ? 'active' : ''}`}
                                                                        onClick={() => handleButtonClickComment(row._id, 'approve')}
                                                                    >
                                                                        <img src="/images/svg/table-true.svg" alt="icon" />
                                                                    </button>
                                                                </div>
                                                            )}

                                                            {(row.status === 1 || row.status === 2) && (
                                                                <button
                                                                    className={`btn btn-light-danger ${selectedActions[row._id] === 'delete' ? 'active' : ''}`}
                                                                    onClick={() => handleButtonClickComment(row._id, 'delete')}
                                                                >
                                                                    <img src="/images/svg/table-delete.svg" alt="icon" />
                                                                </button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                )) : (
                                                    <tr>
                                                        <td colSpan={10} className='text-center p-5 fs-5'>
                                                            No Records Found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap mt-1">
                                        <p className="mb-0 fs-16 fw-500 text-light">
                                            Showing {replyCommentStart} to {replyCommentEnd} of {replyCommentTotalData} entries
                                        </p>

                                        {paginationReplyCommentValue.totalPages > 1 && (
                                            <CustomPagination
                                                currentPage={paginationReplyCommentValue.page}
                                                totalPages={paginationReplyCommentValue.totalPages}
                                                onPageChange={(page) => handlePageChange(page, 'replycomment')}
                                            />
                                        )}
                                    </div>
                                </Tab.Pane>

                                <Tab.Pane eventKey="flaggedStories">
                                    {activeTab === "flaggedStories" && <ReportedStories limit={Number(paginationValue.limit) || 10} />}
                                </Tab.Pane>

                                <Tab.Pane eventKey="flaggedBoard">
                                    {activeTab === "flaggedBoard" && <ReportedBoard limit={Number(paginationValue.limit) || 10} />}
                                </Tab.Pane>

                            </Tab.Content>
                        </Tab.Container>
                    </div>
                </div>
            </Layout>

            <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered>
                <Modal.Body className="text-center">
                    <img src="/images/svg/delete-modal.svg" alt="icon" />
                    <h5 className="my-3">Confirmation</h5>
                    <p className="text-light mb-4 mx-2">
                        {pendingAction.action === 'delete' ?
                            `Are you sure you want to delete this ${activeTab === "flaggedActivity" ? "activity" : "comment"}?` :
                            `Are you sure you want to ${pendingAction.action} this ${activeTab === "flaggedActivity" ? "activity" : "comment"}?`
                        }
                    </p>
                    <div className="d-flex align-items-center justify-content-center gap-3">
                        <button onClick={() => setShowConfirmModal(false)} className="btn btn-outline-light">No</button>
                        <button className="btn btn-primary" onClick={() => {
                            if (pendingAction.action === 'delete') {
                                confirmDeleteActivity();
                            } else {
                                activeTab === "flaggedActivity"
                                    ? confirmActivityAction()
                                    : activeTab === "flaggedReplyComments" ? confirmActionReply() : confirmAction()
                            }
                        }}>
                            Yes, {pendingAction.action}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Image Gallery Modal */}
            <Modal
                show={showImageModal}
                onHide={() => setShowImageModal(false)}
                centered
                size="lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Activity Images</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedImages.length > 0 && (
                        <>
                            <style>{`
                                .activity-carousel .carousel-control-prev-icon,
                                .activity-carousel .carousel-control-next-icon {
                                    filter: invert(0) brightness(0);
                                }
                            `}</style>
                            <Carousel className="activity-carousel">
                                {selectedImages.map((media, index) => {
                                    const mediaUrl = typeof media === 'string' 
                                        ? media 
                                        : (media.url.startsWith('http://') || media.url.startsWith('https://') ? media.url : `${imagePath()}${media.url}`);
                                    const isVideo = typeof media === 'object' && media.type && media.type.startsWith('video/');
                                    
                                    return (
                                        <Carousel.Item key={index}>
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                minHeight: '400px',
                                                backgroundColor: '#f8f9fa'
                                            }}>
                                                {isVideo ? (
                                                    <video
                                                        className="d-block w-100"
                                                        controls
                                                        style={{
                                                            maxHeight: '500px',
                                                            objectFit: 'contain',
                                                            borderRadius: '8px'
                                                        }}
                                                    >
                                                        <source src={mediaUrl} type={media.type} />
                                                        Your browser does not support the video tag.
                                                    </video>
                                                ) : (
                                                    <img
                                                        className="d-block w-100"
                                                        src={mediaUrl}
                                                        alt={`Activity ${index + 1}`}
                                                        title={`Activity ${index + 1}`}
                                                        style={{
                                                            maxHeight: '500px',
                                                            objectFit: 'contain',
                                                            borderRadius: '8px'
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </Carousel.Item>
                                    );
                                })}
                            </Carousel>
                        </>
                    )}
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ActivityManagement